export const statuses: Record<string, { text: string; color: string; textColor: string }> = {
  open: { text: 'Aberto', color: 'abraPurple', textColor: 'white' },
  in_progress: { text: 'Em andamento', color: 'abraGray', textColor: 'white' },
  solved: { text: 'Resolvido', color: 'abraGreen', textColor: 'white' },
  waiting_payment: { text: 'Aguardando pagamento', color: 'abraYellow', textColor: 'black' },
  waiting_for_a_place: { text: 'Aguardando vaga', color: 'magenta', textColor: 'white' },
  in_management_analysis: { text: 'Em análise da gestão', color: 'blue', textColor: 'white' }
}
